import { Outlet, Navigate } from 'react-router-dom'

const PublicRoute = () => {
    const refreshToken = localStorage.getItem('refreshToken')
    const accessToken = localStorage.getItem('accessToken')
    const isAuthorized = (accessToken && refreshToken) ? true : false
    return !isAuthorized ? <Outlet /> : <Navigate to="/dashboard" />
}

export default PublicRoute